import {Component, OnInit, Input} from '@angular/core';
import {JourneyStageDetailsModel} from '../../models/journey-page.model';
import {fadeInOnEnterAnimation} from 'angular-animations';

@Component({
    selector: 'app-learning-journey-text-template',
    templateUrl: './text-template.component.html',
    styleUrls: ['./text-template.component.scss'],
    animations: [fadeInOnEnterAnimation({ anchor: 'enter', duration: 300})]
})
export class LearningJourneyTextTemplateComponent implements OnInit {

    @Input() stage: JourneyStageDetailsModel;

    constructor() {
    }

    ngOnInit() {
    }
}
